import type { PaginationResponse } from "@/types/serverResponse";
import { axios_instance } from "./api";

export interface User {
  id: string;
  username: string;
  password: string;
  role: string;
  avatar_seed?: string;
  created_at: number;
  updated_at: number;
  enable: boolean;
}

export const fetchUsers = (
  keyword: string = "",
  page: number = 1,
  size: number = 10,
  status: boolean[] = [true, false],
) => {
  const payload = {
    keyword,
    page,
    size,
    status,
  };

  return axios_instance.post<PaginationResponse<User>>(
    "/api/v1/view/user/pagination",
    payload,
  );
};

export const createUser = (
  username: string,
  password: string,
  role: string = "operator",
  avatar_seed?: string,
) => {
  const payload = {
    username,
    password,
    role,
    avatar_seed,
  };

  return axios_instance.post<User>("/api/v1/view/user/", payload);
};

export const deleteUser = (id: string) => {
  return axios_instance.delete(`/api/v1/view/user/${id}`);
};

export const updateUser = (
  id: string,
  username?: string,
  password?: string,
  enable?: boolean,
  role?: string,
  avatar_seed?: string,
) => {
  const payload: Record<string, unknown> = {};
  if (username !== undefined) {
    payload.username = username;
  }
  if (password !== undefined) {
    payload.password = password;
  }
  if (enable !== undefined) {
    payload.enable = enable;
  }
  if (role !== undefined) {
    payload.role = role;
  }
  if (avatar_seed !== undefined) {
    payload.avatar_seed = avatar_seed;
  }

  return axios_instance.post<User>(`/api/v1/view/user/${id}`, payload);
};
